import React from "react";
import { Form, Input, Button, message, Checkbox,DatePicker,Radio,Select,Card,Popover } from "antd";
import PrivacyPolicy from "Pages/Others/PrivacyPolicy";
import { addNewPatientData, addSubscriptionStatus } from "store/slice/offlinePatient-slice";
import '../CareAdmin/OfflinePatientForm.scss';
import { validateErrMessages } from "../../Common/constant";
import TermsofUse from "Pages/Others/TermsofUse";
import { placeholder } from "Common/constant"
import "antd/dist/reset.css";
import { consentformstring } from "Common/constant";
import Validators from "../../Common/Validators";
import api from "utils/api";
import dayjs from "dayjs";
import utils from "utils";
import InputComponent from "Components/InputComponent";
import CommonButton from "Components/CommonButton";
import DependentCardComponent from 'Components/DependentCardComponent';
const requiredMessage = "This field cannot be empty";
import PhoneInput, {
  isValidPhoneNumber,
  formatPhoneNumber,
  formatPhoneNumberIntl,
} from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { CONSTANTS } from "utils/constant";
import "./Authentication.scss";
import { connect } from "react-redux";
import Icons from "Common/Icons";
import "Components/Styles/BackButton.scss";
const relations = [
  { label: "Brother", value: "Brother" },
  { label: "Cousin", value: "Cousin" },
  { label: "Daughter", value: "Daughter" },
  { label: "Father", value: "Father" },
  { label: "Friend", value: "Friend" },
  { label: "Granddaughter", value: "Granddaughter" },
  { label: "Grandfather", value: "Grandfather" },
  { label: "Grandmother", value: "Grandmother" },
  { label: "Grandson", value: "Grandson" },
  { label: "Husband", value: "Husband" },
  { label: "Mother", value: "Mother" },
  { label: "Niece", value: "Niece" },
  { label: "Nephew", value: "Nephew" },
  { label: "Sister", value: "Sister" },
  { label: "Son", value: "Son" },
  { label: "Wife", value: "Wife" },
  { label: "Other", value: "Other" },
];
class OfflinePatientRegister extends React.Component {
  signupForm = React.createRef();
  constructor(props) {
    super(props);
    const { state } = this.props.location;  
    const account_holder_mobile_number = state?.patientData?.mobile_number || '';
    const country_code = state?.patientData?.country_code || '';
    const fullPhoneNumber = country_code + account_holder_mobile_number;
    this.state = {
      loading: false,
      enabler: {},
      formAction: false,
      userType: state?.userType || 1,
      selectedCard: state?.userType || 1,
      show_signup_field: state?.patientData?.mobile_number?true:false,      
      formData: {
        is_whatsapp_optin: true,
        patient_user_id:state?.patientData?.patient_user_id || '',
        account_holder_name: state?.patientData?.patient_name || '',
        account_holder_last_name: state?.patientData?.patient_last_name || '',
        email: state?.patientData?.email_id || '',
        mobile_number: fullPhoneNumber || '',
        // relationship: state?.patientData?.patient_relation_with_account_owner || '',
        dob: state?.patientData?.dob ? dayjs(state.patientData.dob) : '',
      }
    };
    this.form = React.createRef();
  }
  consentformsubmit(val) {
    let { patientname, name, parentname, dob, date, parentdate } = val;
    this.form.current?.setFieldsValue({ consent : true });
    this.setState({ accept: { ...this.state.accept, consent: false } });
    utils.Modal(false);
  }
  componentDidMount(){
    this.props.addSubscriptionStatus(false)
  }
  consent() {
    utils.Modal(true, {
      width: "800px",
      //closable:false,
      title: (
        <h3 
        // className="modal-consent-form"
        className="term-header"
        >
          Parental Consent for Child/Adolescent Health 
          Treatment
        </h3>
      ),
      content: (
        <div style={{ padding: "10px 30px 30px 30px", height: "80vh" }}>
          <Form
            name="consentform"
            ref={this.consentform}
            initialValues={{ remember: true }}
            onFinish={this.consentformsubmit.bind(this)}
            validateTrigger={["onBlur"]}
            labelAlign="left"
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 16,
            }}
          >
            <Form.Item
              name="patientname"
              label={
                this.state?.userType == 2 ? "Name" : "Name of Care Receiver"
              }
              //rules={[{required: true,message: 'This field cannot be empty',}]}
            >
              <Input
                className="input-box"
                defaultValue={
                  this.state?.userType == 2
                    ? utils.getDisplayName(
                        this.form.current?.getFieldsValue()?.care_reciever_name, this.form.current?.getFieldsValue()?.care_receiver_last_name || ""
                      )
                    : utils.getDisplayName(
                        this.form.current?.getFieldsValue()?.account_holder_name, this.form.current?.getFieldsValue()?.account_holder_last_name || ""
                      )
                }
                disabled={true}
                style={{ width: "70%" }}
              />
            </Form.Item>
            <Form.Item
              name="dob"
              label="Date of Birth:"
              labelWrap
              //rules={[{required: true,message: 'This field cannot be empty',}]}
            >
              <DatePicker
                style={{width:"100%"}}
                placeholder=""
                // disabledDate={(current) => current < dayjs().subtract(100, "year") ||
                //   dayjs().subtract(2, "year") <= current}
                inputReadOnly={true}
                showToday={false}
                defaultValue={this.form.current?.getFieldsValue()?.dobs}
                disabled={true}
                // onChange={val => {
                //   this.consentform.current.setFieldsValue({
                //     age: dayjs().diff(val, 'years', false)
                //   })
                // }}
              />
            </Form.Item>
            <Form.Item
              name="date"
              label="Date"
              labelWrap
              //rules={[{required: true,message: 'This field cannot be empty',}]}
            >
              <DatePicker
                 style={{width:"100%"}}
                placeholder=""
                superNextIcon={null}
                superPrevIcon={null}
                prevIcon={null}
                nextIcon={null}
                //disabledDate={(current) => current < dayjs().startOf("day") || current > dayjs().endOf("day")}
                defaultValue={dayjs().endOf("day")}
                inputReadOnly={true}
                disabled={true}
                // onChange={val => {
                //   this.consentform.current.setFieldsValue({
                //     age: dayjs().diff(val, 'years', false)
                //   })
                // }}
              />
            </Form.Item>
            <div className="consent-form-content">
            Treatment methods are most effective when a trusting relationship exists between the
             child/adolescent and the doctors. It is hence necessary for children/adolescents 
             to establish a “zone of privacy” with their doctors allowing them to discuss personal
              matters freely
            </div>
            <div className="consent-form-content">
            Therefore, while we will provide you with general information about the treatment
             of your child/adolescent during Parental Check in sessions,
              it may not be possible to share everything that your 
              child/adolescent has disclosed to us as we are dictated by the medical 
              code of conduct and privacy, akin to any client-healthcare provider relationship.
            </div>
            <div className="consent-form-content">
            However, if the child/adolescent is at serious risk of harming him/herself or another,
            or if there are any other issues of medico-legal implications, we will definitely inform you. 
            In case of disagreement among parents themselves and/or disagreement between parents and the doctors regarding the treatment of the child/adolescent, and despite earnest efforts
        to address these disagreements, if either parent decides to terminate treatment, we shall request the option of having a few closing sessions with the child/adolescent to end treatment appropriately without adversely impacting the child/adolescent’s health.
            </div>
            <div className="consent-form-content">
            You will also kindly understand and agree that our role is strictly limited to providing sessions 
            for the benefit of your child/adolescent health and wellness care. Please treat anything said in 
            Parental check-in sessions as strictly confidential. You agree that you will not involve us in any legal dispute, 
            especially those concerning parental separation/divorce proceedings, child custody or visitation arrangements. 
            We are ethically bound not to give our opinion about the suitability of either parent's custody or visitation rights. You will not ask us to testify in court, 
            either in person or by affidavit.
            </div>
            <div className="consent-form-content">
            If you have any questions about the information contained in this contract, 
            please discuss them with us prior to signing below. Clicking yes indicates that you have 
            a) obtained the assent of your child/adolescent implying his approval for his treatment and
             b) you hereby give your consent to your child/adolescent's health assessment and treatment and
              have thereby entered into a legally binding agreement with the terms set forth in this contract.
            </div>
           
            {this.state?.userType == 2 && (
              <Form.Item
                name="parentname"
                label="Parent/Guardian Name"
                //rules={[{required: true,message: 'This field cannot be empty',}]}
              >
                <Input
                  className="input-box"
                  disabled={true}
                  defaultValue={utils.getDisplayName(
                    this.form.current?.getFieldsValue()?.account_holder_name,
                    this.form.current?.getFieldsValue()
                      ?.account_holder_last_name || ""
                  )}
                  style={{ width: "70%" }}
                />
              </Form.Item>
            )}
            <Button className="add-new-member" type="button" htmlType="submit">
              Accept
            </Button>
            <br />
          </Form>
        </div>
      ),
    });
  }


  handleSubmit(values) { 
    this.setState({isButtonLoading:true})
    values.mobile_number =  formatPhoneNumberIntl(this.form.current?.getFieldValue("mobile_number")).split(' ').slice(1).join('') 
    values.country_code =  formatPhoneNumberIntl(this.form.current?.getFieldValue("mobile_number")).split(' ')[0] 
 
    let {
      email,
      mobile_number,
      country_code,
      account_holder_name,
      account_holder_last_name,
      care_reciever_name,
      care_receiver_last_name,
      dob,
      gender,
      relationship,
      allowlogin,
      allownotification,
      dobs,
    } = values || {};

    let usertype =
      this.state.userType == 1 ? "self" : "others" || "others";
    
   
    let consent_values =
      this.state.userType == 1
        ? consentformstring.header +
          " Name of Care Receiver: " +
          care_reciever_name +
          " Last Name of Care Receiver: " +
          care_receiver_last_name +
          " Date of Birth: " +
          utils.FormatDate(dob, "DATE_12") +
          " Date: " +
          utils.FormatDate(dayjs().endOf("day"), "DATE_12") +
          consentformstring.footer +
          " Parent/Guardian Name: " +
          account_holder_name
        : consentformstring.header +
          " Name: " +
          account_holder_name +
          " Last Name: " +
          account_holder_last_name +
          " Date of Birth: " +
          utils.FormatDate(dob, "DATE_12") +
          " Date: " +
          utils.FormatDate(dayjs().endOf("day"), "DATE_12") +
          consentformstring.footer;
    let data = {
      type: "register",
      is_created_by_care_admin:true,
      user_type: usertype,
      source:"website",
      allow_login: usertype == "others" ? allowlogin || false : true,
      allow_notification:
        usertype == "others" ? allownotification || false : true,
      relationship: relationship ? relationship : "self",
      privacy_policy: true,
      terms_and_condition: true,
      consent: this.state?.dob < 18 ? true : false,
      consent_values: this.state?.dob < 18 ? consent_values : "",
      is_whatsapp_opt_in: values.is_whatsapp_optin,
      data:
        usertype == "others"
          ? [
              {
                name: account_holder_name ? account_holder_name.trim() : "",
                last_name: account_holder_last_name
                  ? account_holder_last_name.trim()
                  : "",
                country_code,
                mobile_number,
                email: email,
                dob:
                  usertype == "others"
                    ? utils.FormatDate(dob, "DATE_12")
                    : utils.FormatDate(dobs, "DATE_12"),
                gender: usertype != "others" ? gender : "",
                is_account_holder: true,
                time_zone_offset_in_min: utils.getOffSetInMinute() || +330,
              },
              {
                name: care_reciever_name ? care_reciever_name.trim() : "",
                last_name: care_receiver_last_name
                  ? care_receiver_last_name.trim()
                  : "",
                country_code: "",
                mobile_number: "", //care_receiver_number||'',
                email: "", //email?.toLowerCase()||'',
                
                dob:
                  usertype == "others" ? utils.FormatDate(dobs, "DATE_12") : "",
                gender: usertype == "others" ? gender : "",
                is_account_holder: false,
                time_zone_offset_in_min: utils.getOffSetInMinute() || 330,
              },
            ]
          : [
              {
                name: account_holder_name ? account_holder_name.trim() : "",
                last_name: account_holder_last_name
                  ? account_holder_last_name.trim()
                  : "",
                 country_code,
                mobile_number,
                email: email,
                dob:
                  usertype != "others" ? utils.FormatDate(dob, "DATE_12") : "",
                gender: usertype != "others" ? gender : "",
                is_account_holder: true,
                time_zone_offset_in_min: utils.getOffSetInMinute() || 330,
              },
            ],
    };
    let ProfileCreateData={
        "parent_user_id":this.state?.formData?.patient_user_id||"",
        "name": care_reciever_name ? care_reciever_name.trim() : "",
        "last_name": care_receiver_last_name
        ? care_receiver_last_name.trim()
        : "",
        "dob": usertype == "others" ? utils.FormatDate(dobs, "DATE_12") : "",
        "gender":usertype == "others" ? gender : "",
        "relationship": relationship ? relationship : "self",
        "allow_login": usertype == "others" ? allowlogin || false : true,
        "privacy_policy": true,
        "terms_and_condition": true,
        "consent":this.state?.dob < 18 ? true : false,
        "source": "website",
        "time_zone_offset_in_min": utils.getOffSetInMinute() || 330,
        "consent_values":this.state?.dob < 18 ? consent_values : "",} 
    const apiCall = this.state.formData.patient_user_id? api.careAdminProfileCreate : api.offline_register;
    let payload=this.state.formData.patient_user_id?ProfileCreateData:data;
    apiCall(payload)
      .then((res)=>{
        this.setState({isButtonLoading:false})
        if(res.data.status==200){
          message.success(res.data.message)
          this.props.addNewPatientData(res.data.data?.[0])
          this.props.history.push({
            pathname:"/care-admin/new-user",
          })
          }else{
            message.error(res.data.message)
            this.setState({isButtonLoading:false})
          }
        })
       .catch((err)=>message.error(err.data.message),
       this.setState({isButtonLoading:false}))
  }

  newUserData(){
    this.props.history.push({
      pathname:"/care-admin/new-user"
    })
  }
   unsavedPopup=()=>{
  utils.Modal(true, {
    width: "650px",
    // closable: false,
    content:
    <div style={{height:"200px"}} className="finish-Consult-Modal">
    <div className="finish-header">Confirmation</div>
    <div style={{padding:"20px"}}>
        <div className="finish-title">There are unsaved changes. Are you sure to go back?</div>
        <div style={{float:"inline-end",marginTop:"30px",gap:"1rem",display:"flex"}} className="finish-btns" >
            <CommonButton className="common-button-red" onClick={() => { this.setState({show_signup_field:false}),utils.Modal(false)}} label={`${CONSTANTS.YES}`}/>
            <CommonButton className="common-button-green" onClick={() => { utils.Modal(false)}} label={`${CONSTANTS.NO}`}/>
        </div>
    </div>
</div>
  })
 }
 onchangemobile(value) {
  if(value && isValidPhoneNumber(value)){
      this.setState({ enabler: { ...this.state.enabler, mobilegenerate: true } })  }
  else{
    this.setState({ enabler: { ...this.state.enabler, mobilegenerate: false } })
  }
}





  render() {
    const dependentCardData = [
      {
        title: `${CONSTANTS.CARE_ADMIN_FOR_INDIVIDUAL}`,
        subTitle: `${CONSTANTS.CARE_ADMIN_FOR_INDIVIDUAL_DESCRIPTION}`
      },
      {
        title: `${CONSTANTS.CARE_ADMIN_FOR_DEPENDANT}`,
        subTitle: `${CONSTANTS.CARE_ADMIN_FOR_DEPENDANT_DESCRIPTION}`
      }
    ]
    const style = {
      justifyContent: this.state.loading ? "center" : "space-between",
    };
    const props_patient_user_id=this.state.formData.patient_user_id;
    return (
      <div className="authentication-container offline-reg-container">
         
                    
                  {!this.state.show_signup_field ?
                  <>
                  
                  <Card style={{width:"50%",margin:"20px auto"}} >
                  <h3 className="authentication-title">
                   Choose  Account type
                    </h3>
                    <div style={{display:"flex",height:"60vh",flexDirection:"column",justifyContent:"space-between"}}>
                  <div className="select-user-type">
                     {!this.state.enabler?.['email'] && <Form.Item
          name="userType"
          labelAlign='left'
          labelWrap
          rules={[{
            required: true,
            message:`${CONSTANTS.VALIDATION_MESSAGE}`,
          }]}>
         
          <Radio.Group style={{display:"flex" ,gap:"1rem"}} className='sign-up-dependent-card-container' onChange={(value) => {
             this.setState({ userType: value.target.value+1, selectedCard: value.target.value+1 }) }}  >
            {dependentCardData.map((data, i)=>{
              return(<DependentCardComponent title={data.title} subTitle={data.subTitle} index={i} selectedKey = {this.state.selectedCard}/>)
            })}
          </Radio.Group>
        </Form.Item>}
        </div>
        {(this.state.selectedCard == 2 && !this.state.enabler?.['email'])&& (
          <div className='for-dependant'>
            <ul className='ul-for-dependant'>
              {/* <li>{CONSTANTS.IAM_GUARDIAN}</li> */}
              <li>{CONSTANTS.CARE_ADMIN_IAM_CREATING}</li>
            </ul>
          </div>
        )}
   
        <CommonButton style={{margin:"20px auto"}} className="common-button-green" disabled={!this.state.userType} onClick={()=>this.setState({show_signup_field:true})} label={"Continue"}/>
        </div>
        </Card>
        </>

      :
      <>
      
      {/* <CommonButton className="common-button-green backButton"   label={"Back"} /> */}
      <Button className="back-btn" 
      // onClick={()=>{this.state.formAction?this.unsavedPopup():this.setState({show_signup_field:false})}} 
      onClick={() => {
        if (this.state.formAction) {
          this.unsavedPopup();
        } else {
          if (this.state.userType === 2 && props_patient_user_id) {
            this.props.history.push(`${this.props.user_details?.baseUrl}/patient-lists`); 
          } else {
            this.setState({ show_signup_field: false });
          }
        }
      }} 
      >
                <img className="back-btn-img" src={Icons.back_btn_icon}/>
                Back
            </Button>
        <Card className="form-card" style={{width:"80%",margin:"20px auto"}}>
                 <Form
                 colon={false}
                 size={"medium"}
                 className={"offline-reg-form"}
                  name="signup"
                  ref={this.form}
                  initialValues={this.state.formData}
                  onFinish={this.handleSubmit.bind(this)}
                  onFieldsChange={()=>{if(!this.state?.formAction)this.setState({formAction:true})}}
                  autoComplete="on"
                  validateTrigger={["onBlur"]}
                  labelAlign="left"
                  labelCol={{
                    span: 8,
                  }}
                  wrapperCol={{
                    span: 12,
                  }}
                >
                    <h3 className="authentication-title">
                      Account Holder Details
                    </h3>
                  <div className="sign-up-1st-last-name-conatiner">
                  <InputComponent
                    className="input-box-name"
                    placeholder={CONSTANTS.ENTER_ACCH_NAME}
                    label={
                      this.state.userType == 2
                        ? "Account Holder First Name"
                        : "First Name"
                    }
                    disabled={!!props_patient_user_id}
                    name="account_holder_name"
                    rules={[
                      {
                        required: true,
                        message: ``,
                      },
                      Validators.validateFirstName,
                    ]}
                    validateTrigger={["onChange", "on Blur"]}
                    
                    maxLength={50}
                    onChange={(e) => {
                      this.setState({
                        account_holder_name: e,
                        accept: { ...this.state.accept, consent: true },
                      });
                    }}
                  />
                 
                  <InputComponent
                    placeholder={CONSTANTS.ENTER_ACCH_LAST_NAME}
                    className="input-box-name"
                    label={
                      this.state.userType == 2
                        ? "Account Holder Last Name"
                        : "Last Name"
                    }
                    name="account_holder_last_name"
                    disabled={!!props_patient_user_id}
                    validateTrigger={["onChange", "onBlur"]}
                    rules={[Validators.validateLastName]}
                    maxLength={50}
                    onChange={(e) => {
                      this.setState({
                        account_holder_last_name: e,
                        accept: { ...this.state.accept, consent: true },
                      });
                    }}
                  />
                  </div>
                  <Form.Item
                  // label={"Custom First Form"}                  
                  name="email"
                  label="Email"
                  rules={[
                    {
                      required: true,
                      message: `${CONSTANTS.CARE_ADMIN_VALIDATION_EMAIL_MESSAGE}`,
                    },
                    //countrycode
                    // ()=>Validators.checkMobileEmailwithcountry(this.state.country_code)
                    Validators.checkEmail
                  ]}
                >
                  <Input className='input-box'  
                  placeholder={CONSTANTS.ENTER_ACCH_EMAIL}
                  disabled={!!props_patient_user_id}
                  onChange={(e)=>{this.setState({phone_number:e.target.value})}}
                  
                  />
                </Form.Item>
                <Form.Item
                  name="mobile_number"
                  label="Mobile Number"
                  style={{width:"100%"}}  
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                       
                    { required:true,
                      validator: (_, value) =>

                      value?isValidPhoneNumber(value) ? Promise.resolve() : Promise.reject('Please enter a valid mobile number'):Promise.reject(`${CONSTANTS.CARE_ADMIN_VALIDATION_MOBILENUMBER_MESSAGE}`)

                        },
                  ]}
                >
                    <div  className='mobile-input'>
                    <PhoneInput
                    className='signup-mobile-input'
                    placeholder={CONSTANTS.ENTER_YOUR_MOBILE}
                    international={true}     
                    defaultCountry="IN" 
                    disabled={!!props_patient_user_id}
                    value={this.state.formData.mobile_number}  
                    onChange={this.onchangemobile.bind(this)}
                    onCountryChange={(value)=>typeof value=="string"?this.setState({show_mobile_text:true}):this.setState({show_mobile_text:false})}            
                
                  
                    />
                    </div>
                </Form.Item>  
                
                    <Form.Item
                      name="dob"
                      label="Date of Birth"
                      labelWrap
                      rules={[
                        {
                          required: true,
                          message: requiredMessage,
                        },
                      ]}
                    >
                      <DatePicker
                       style={{width:"100%"}}
                        className="input-box"
                        // style={{ width: "100%" }}
                        placeholder={CONSTANTS.DATE_FORMAT}
                        disabled={!!props_patient_user_id}
                        renderExtraFooter={() => <span style={{paddingLeft : "14px"}}>{CONSTANTS.DATE_FOOTER_MESSAGE}</span>}
                        //disabledDate={(current) => current.isAfter(dayjs().subtract(1, "day"))}
                        disabledDate={(current) =>
                          current < dayjs().subtract(100, "year") ||
                          dayjs().subtract(18, "year") <= current
                        }
                        // defaultValue={dayjs(dayjs(dayjs().subtract(18, "year")).format(CONSTANTS.DATE_FORMAT), CONSTANTS.DATE_FORMAT)}
                        // inputReadOnly={true}
                        showToday={false}
                        onChange={(val) => {
                          // this.form.current.setFieldsValue({
                          //   age: dayjs().diff(val, 'years', false)
                          // })
                          this.setState({
                            dobs: dayjs().diff(val, "years", false),
                            accept: { ...this.state.accept, consent: true },
                          });
                        }}
                      />
                    </Form.Item>
                    {this.state.userType == 1 && (
                    <Form.Item
                    name="gender"
                    label="Gender"
                    labelWrap
                    rules={[
                      {
                        required: true,
                        message: requiredMessage,
                      },
                    ]}
                  >
                    <Select className="input-box" placeholder={placeholder.dropdown}>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="others">Others</option>
                    </Select>
                  </Form.Item>)}
                  {this.state.userType == 2 && (
                    <Form.Item
                      name="relationship"
                      label="Relationship with Dependent"
                      labelWrap
                      rules={[
                        {
                          required: true,
                          message: requiredMessage,
                        },
                      ]}
                    >
                      <Select
                        className="input-box"
                        placeholder={placeholder.dropdown}
                        options={relations}
                        onChange={(e) => {
                          this.setState({
                            relationship: e,
                            accept: { ...this.state.accept, consent: true },
                          });
                        }}
                      />
                    </Form.Item>
                  )}
                
                  
               
                  {this.state.userType == 2 && (
                    <h3 className="authentication-title">
                      Care Receiver Details
                    </h3>
                  )}
                  {this.state.userType == 2 && (
                    <div className="sign-up-1st-last-name-conatiner">
                      <InputComponent
                      placeholder={CONSTANTS.ENTER_CARE_REC_NAME}
                        className="input-box-name"
                        label={
                          this.state.userType == 2
                            ? "Care Receiver First Name"
                            : "Name"
                        }
                        name="care_reciever_name"
                        rules={[
                          {
                            required: true,
                            message: ``,
                          },
                          Validators.validateFirstName,
                        ]}
                        validateTrigger={["onChange", "onBlur"]}
                        disabled={this.state.loading}
                        maxLength={50}
                        onChange={(e) => {
                          this.setState({
                            care_reciever_name: e,
                            accept: { ...this.state.accept, consent: true },
                          });
                        }}
                      />
                      <InputComponent
                      placeholder={CONSTANTS.ENTER_CARE_REC_LNAME}
                        className="input-box-name"
                        label={
                          this.state.userType == 2
                            ? "Care Receiver Last Name"
                            : "Name"
                        }
                        name="care_receiver_last_name"
                        rules={[Validators.validateLastName]}
                        validateTrigger={["onChange", "onBlur"]}
                        maxLength={50}
                        onChange={(e) => {
                          this.setState({
                            care_receiver_last_name: e,
                            accept: { ...this.state.accept, consent: true },
                          });
                        }}
                      />
                    </div>
                  )} 
                    
                 {this.state.userType == 2 && (
                  <>
                  <Form.Item
                    name="dobs"
                    label="Date of Birth"
                    labelWrap
                    rules={[
                      {
                        required: true,
                        message: requiredMessage,
                      },
                    ]}
                  >
                    <DatePicker
                     style={{width:"100%"}}
                      className="input-box"
                      // style={{ width: "100%" }}
                      placeholder={CONSTANTS.DATE_FORMAT}
                      renderExtraFooter={() => <span style={{paddingLeft : "14px"}}>{CONSTANTS.DATE_FOOTER_MESSAGE}</span>}
                      // defaultValue={dayjs(dayjs(this.state.userType == 2 ? dayjs().subtract(2, "year") : dayjs().subtract(18, "year")).format(CONSTANTS.DATE_FORMAT), CONSTANTS.DATE_FORMAT)}
                      //disabledDate={(current) => current.isAfter(dayjs().subtract(1, "day"))}
                      disabledDate={(current) =>
                        current < dayjs().subtract(100, "year") ||
                        (this.state.userType == 2
                          ? dayjs().subtract(2, "year") <= current
                          : dayjs().subtract(18, "year") <= current)
                      }
                      // inputReadOnly={true}
                      showToday={false}
                      onChange={(val) => {
                        this.form.current.setFieldsValue({
                          age: dayjs().diff(val, "years", false),
                        });
                        this.setState({
                          dob: dayjs().diff(val, "years", false),
                          accept: { ...this.state.accept, consent: true },
                        });
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    name="gender"
                    label="Gender"
                    labelWrap
                    rules={[
                      {
                        required: true,
                        message: requiredMessage,
                      },
                    ]}
                  >
                    <Select className="input-box" placeholder={placeholder.dropdown}>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="others">Others</option>
                    </Select>
                  </Form.Item>
                  </>)}                
                   {/* <Form.Item
                  name="terms"
                  valuePropName='checked'
                  validateTrigger={["onChange"]}
                  rules={[
                    {
                      validator: (_, value) => value ? Promise.resolve() : Promise.reject("Please accept terms and conditions")
                    },
                  ]}
                >
                  <Checkbox className='terms-conditions'>By registering with us, you agree to the <span className='privacy-link'>Terms & Conditions</span> and <span className='privacy-link'>Privacy Policy.</span></Checkbox>
                </Form.Item>  */}
                   {/* {this.state.userType == 2 && <Form.Item
                  name="allowlogin"
                  valuePropName='checked'
                  validateTrigger={["onChange"]}
                >
                  <Checkbox disabled={true }className='terms-conditions'>Allow Login for Care Receiver</Checkbox>
                </Form.Item>}
                {this.state.userType == 2 && <Form.Item
                  name="allownotification"
                  valuePropName='checked'
                  validateTrigger={["onChange"]}
                >
                  <Checkbox disabled={true} className='terms-conditions'>Allow Notification for Care Receiver</Checkbox>
                </Form.Item>}  */}

                   {(this.state?.userType == 1
                    ? true
                    : this.form.current?.getFieldsValue()?.care_reciever_name &&
                      this.form.current?.getFieldsValue()?.relationship &&
                      this.form.current?.getFieldsValue()?.dobs) &&
                    this.form.current?.getFieldsValue()?.dob &&
                    this.form.current?.getFieldsValue()
                      ?.account_holder_name && (
                      <div>
                        <Popover
                          {...(this.state?.accept?.termsofuse ||
                          this.state?.accept?.privacypolicy
                            ? ""
                            : { open: false })}
                          trigger={
                            this.state?.accept?.termsofuse ||
                            this.state?.accept?.privacypolicy
                              ? "hover"
                              : ""
                          }
                          content={validateErrMessages.termAndCondition}
                          placement="topLeft"
                        >
                          <Form.Item
                            name="terms"
                            valuePropName="checked"
                            validateTrigger={["onChange"]}
                            rules={[Validators.validateTermAndCondition]}
                            wrapperCol={{ span: 24 }}
                          >
                            <Checkbox
                              className="terms-conditions"
                              //disabled={this.state?.accept?.termsofuse || this.state?.accept?.privacypolicy}
                            >
                              <span style={{ color: "black" }}>
                                By registering with us,{" "}
                                {/* {this.state?.userType == 1
                                  ? ""
                                  : "On Behalf of Care Receiver "} */}
                                You agree to the{" "}
                              </span>
                              <a
                                // href="https://www.niyama.ai/company/terms"
                                target="_blank"
                                rel="noreferrer noopener"
                                className="privacy-link"
                                
                                
                                style={{
                                  color:
                                    this.state?.accept?.termsofuse == false
                                      ? "#1677ff"
                                      : "#1677ff",
                                  fontWeight: "bolder",
                                  textDecoration: "underline",
                                }}
                              >
                                Terms and Conditions,
                              </a>
                              <a
                                // href="https://www.niyama.ai/company/privacy"
                                target="_blank"
                                rel="noreferrer noopener"
                                className="privacy-link"
                                onClick={() =>
                                  this.setState({
                                    accept: {
                                      ...this.state.accept,
                                      privacypolicy: false,
                                    },
                                  })
                                }
                                style={{
                                  color:
                                    this.state?.accept?.privacypolicy == false
                                      ? "#1677ff"
                                      : "#1677ff",
                                  fontWeight: "bolder",
                                  textDecoration: "underline",
                                }}
                              >
                                {" "}
                                Privacy Policy
                              </a>
                            </Checkbox>
                          </Form.Item>
                        </Popover>
                         
                        {this.state.dob < 18 && <Popover
                            trigger={
                              this.state?.accept?.consent &&
                              this.state?.dob < 18
                                ? "hover"
                                : ""
                            }
                            content={
                              validateErrMessages.adolscentTermAndCondtion
                            }
                            placement="topLeft"
                          >
                            <Form.Item
                              name="consent"
                              valuePropName="checked"
                              validateTrigger={["onChange"]}
                              rules={[Validators.validateTermAdolscent]} 
                              wrapperCol={{ span: 24 }}
                            >
                              <Checkbox
                                className="terms-conditions"
                                disabled={
                                  this.state?.accept?.consent &&
                                  this.state?.dob < 18
                                }
                              >
                                <span style={{ color: "black" }}>
                                  Agree to{" "}
                                  <a
                                    className="privacy-link"
                                    onClick={this.consent.bind(this)}
                                    style={{
                                      color:
                                        this.state?.accept?.consent == false
                                          ? "#1677ff"
                                          : "#1677ff",
                                      fontWeight: "bolder",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    Parental Consent for Child/Adolescent
                                    Health  Treatment
                                  </a>
                                </span>
                              </Checkbox>
                            </Form.Item>
                          </Popover> }
                        
                        <Form.Item
                          name="is_whatsapp_optin"
                          valuePropName="checked"
                          wrapperCol={{ span: 24 }}
                        >
                          <Checkbox className="">
                            I agree to have my notifications sent via WhatsApp
                          </Checkbox>
                        </Form.Item>
                      </div>
                    )} 
                      </Form>
                      <div style={{textAlign:"center"}}>
                      <CommonButton loading={this.state.isButtonLoading} style={{margin:"20px auto"}} className="common-button-green"  onClick={()=>this.form.current.submit()} label={`${CONSTANTS.SAVE}`} />
                      </div>
                      </Card>
                  </>}
                  {this.state.open_privacy_policy || this.state.open_terms_of_use ? (
          <Modal
            width="90%"
            centered={true}
            bodyStyle={{ overflowY: "auto", maxHeight: "calc(100vh - 20vh)" }}
            okText="Accept"
            onOk={() =>
              this.setState({
                open_privacy_policy: this.state.open_privacy_policy
                  ? false
                  : this.state.accept.privacypolicy
                  ? true
                  : false,
                open_terms_of_use: this.state.open_terms_of_use
                  ? false
                  : this.state.accept.termsofuse
                  ? true
                  : false,
                accept: {
                  ...this.state.accept,
                  termsofuse: this.state.open_terms_of_use
                    ? false
                    : this.state.accept.termsofuse,
                  privacypolicy: this.state.open_privacy_policy
                    ? false
                    : this.state.accept.privacypolicy,
                },
              })
            }
            onCancel={() =>
              this.setState({
                open_privacy_policy: false,
                open_terms_of_use: false,
              })
            }
            afterClose={() =>
              this.setState({
                open_privacy_policy: false,
                open_terms_of_use: false,
              })
            }
            title={
              <h3
                style={{
                  lineHeight: "2.5",
                  textAlign: "center",
                  background: "#9573DF",
                }}
              >
                {this.state.open_terms_of_use
                  ? "Accept Terms of Use"
                  : "Accept Privacy Policy"}
              </h3>
            }
            open={
              this.state.open_privacy_policy || this.state.open_terms_of_use
            }
          >
            {this.state.open_terms_of_use ? <TermsofUse /> : <PrivacyPolicy />}
          </Modal>
        ) : null}
              
              </div> 
    
    );
  }
}
const mapStateToProps = (state) => {
  return {
      user_details: state.loginReducer.user_details,
      history_state: state.historyReducer?.history_state,
  }
}
const mapDispatchToProps ={
  addNewPatientData,
  addSubscriptionStatus
};
export default connect(mapStateToProps,mapDispatchToProps)(OfflinePatientRegister);